export const ASSOCIATE_EMAIL =
  process.env.ASSOCIATE_EMAIL || "associate@mail.sociuslegal.com";
export const SUPPORT_EMAIL =
  process.env.SUPPORT_EMAIL || "support@sociuslegal.com";
